{
  "brand": "NAPAICP (NAPAI Competition Platform)",
  "headerBrand": "NAPAICP",
  "siteUrl": "https://aicp.ntpu.ai/",
  "securityContactEmail": "aintpu@gmail.com",
  "breadcrumb": "Breadcrumb",
  "competition": {
    "officialWebsite": "Official website ↗",
    "officialWebsiteAriaLabel": "Open {{name}}'s official website (new tab)",
    "logoAlt": "{{name}} logo"
  },
  "lastUpdated": "Last updated",
  "calloutNote": "Note",
  "files": {
    "preview": "Preview",
    "download": "Download",
    "downloadFailed": "Could not get a download link.",
    "selectFile": "Choose a file to preview",
    "previewError": "Couldn't load the submission preview",
    "previewErrorReasons": "Possible causes: the link expired, or a network issue.",
    "retryPreview": "Reload preview",
    "retryDownloadLink": "Get a new download link",
    "previewFatalError": "Please reload the page."
  },
  "state": {
    "loading": "Loading…",
    "checking": "Checking…",
    "error": "Something went wrong.",
    "empty": "Nothing here yet.",
    "notSignedIn": "Not signed in",
    "signedIn": "Signed in"
  },
  "action": {
    "signOut": "Sign out",
    "signIn": "Sign in",
    "signingIn": "Signing in…",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving…",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "select": "Select…",
    "back": "Back",
    "close": "Close",
    "confirm": "Confirm",
    "retry": "Retry",
    "skipToContent": "Skip to main content"
  },
  "placeholder": {
    "title": "Not available yet",
    "description": "This screen is a placeholder. Nothing on it reads or writes competition data yet."
  },
  "footer": {
    "tagline": "A multi-competition platform for managing teams, submissions, judging and results.",
    "poweredBy": "Powered by NAPAI × NTPU AI4X",
    "copyright": "© {{year}} <brandLink>NAPAICP (NAPAI Competition Platform)</brandLink>"
  },
  "status": {
    "title": "Platform status",
    "description": "Live health of the API and your current session.",
    "api": {
      "title": "API",
      "description": "Live probe of the worker and its bindings.",
      "unreachable": "API unreachable",
      "reachable": "reachable",
      "failed": "failed"
    },
    "session": {
      "title": "Session",
      "description": "Held in an HttpOnly cookie. Nothing about it is readable by script.",
      "globalRole": "Global role"
    },
    "competition": {
      "draft": "Draft",
      "published": "Published",
      "registration_open": "Registration open",
      "submission_open": "Submissions open",
      "judging": "Judging",
      "completed": "Completed",
      "archived": "Archived"
    },
    "formVersion": {
      "draft": "Draft",
      "published": "Published",
      "superseded": "Superseded"
    },
    "resultRun": {
      "draft": "Draft",
      "calculated": "Calculated",
      "locked": "Locked",
      "published": "Published"
    },
    "submission": {
      "draft": "Draft",
      "ready": "Ready",
      "submitted": "Submitted",
      "locked": "Locked",
      "withdrawn": "Withdrawn",
      "disqualified": "Disqualified"
    },
    "file": {
      "pending": "Pending",
      "completed": "Completed",
      "aborted": "Aborted"
    },
    "assignment": {
      "active": "Active",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "competitionRole": {
      "competition_admin": "Competition admin",
      "staff": "Staff",
      "student": "Student",
      "teacher": "Teacher",
      "judge": "Judge",
      "observer": "Observer"
    },
    "platformRole": {
      "user": "User",
      "super_admin": "Super admin"
    },
    "teamRole": {
      "leader": "Leader",
      "member": "Member",
      "teacher": "Teacher"
    },
    "team": {
      "active": "Active",
      "disbanded": "Disbanded"
    },
    "user": {
      "active": "Active",
      "suspended": "Suspended",
      "deleted": "Deleted"
    },
    "competitionRequest": {
      "draft": "Draft",
      "submitted": "Awaiting review",
      "under_review": "Under review",
      "changes_requested": "Awaiting applicant",
      "approved": "Approved",
      "rejected": "Rejected",
      "cancelled": "Cancelled"
    }
  },
  "notFound": {
    "title": "Page not found",
    "description": "There is nothing at this address.",
    "back": "Back to home"
  },
  "devSignIn": {
    "title": "Development sign-in",
    "description": "Local environment only, for testing with a seeded account.",
    "email": "Email",
    "password": "Password",
    "failed": "Sign-in failed."
  },
  "passwordVisibility": {
    "show": "Show password",
    "hide": "Hide password"
  },
  "googleSignIn": {
    "action": "Sign in with Google"
  },
  "register": {
    "title": "Create an account",
    "description": "Sign up with your email and a password.",
    "displayName": "Display name",
    "passwordHint": "Must be at least 10 characters.",
    "action": "Create account",
    "failed": "Registration failed.",
    "checkEmail": "Check your email for a verification link to finish creating your account.",
    "haveAccount": "Already have an account?"
  },
  "loginPage": {
    "title": "Sign in",
    "description": "Continue with your account.",
    "orSeparator": "or",
    "noAccount": "Don't have an account?",
    "needAccount": "Create an account",
    "forgotPassword": "Forgot password?",
    "devTools": "Development sign-in"
  },
  "forgotPassword": {
    "title": "Forgot password",
    "description": "We'll email you a link to reset your password.",
    "action": "Send reset link",
    "checkEmail": "If an account exists for that email, a reset link is on its way."
  },
  "resetPassword": {
    "title": "Reset password",
    "description": "Choose a new password for your account.",
    "newPassword": "New password",
    "passwordHint": "Must be at least 10 characters.",
    "action": "Reset password",
    "failed": "Unable to reset your password.",
    "success": "Your password has been reset. You can now sign in.",
    "invalidLink": "This password reset link is invalid or has expired."
  },
  "forcedPasswordChange": {
    "title": "Set your new password",
    "description": "You signed in with a one-time temporary password. Set your own password to continue; you won't be able to use the rest of the site until this is done.",
    "newPassword": "New password",
    "passwordHint": "Must be at least 10 characters.",
    "action": "Set password and continue",
    "failed": "Unable to set your new password.",
    "success": "Your password has been set. Loading the site…"
  },
  "bootstrapPage": {
    "title": "Platform initialization",
    "description": "Grant the first platform Super Admin using the deployment bootstrap credential.",
    "signInFirst": "Sign in with a verified, active account before starting platform initialization.",
    "goToSignIn": "Go to sign in",
    "oneTimeNoticeTitle": "One-time platform initialization",
    "oneTimeNoticeBody": "This is a one-time step performed by the deployment operator. Creating an account does not make anyone a Super Admin automatically; this form is the only way the platform's first Super Admin is granted, and it stops working the moment a Super Admin already exists.",
    "credentialLabel": "Bootstrap credential",
    "submitAction": "Initialize platform",
    "submitting": "Initializing...",
    "failed": "Platform initialization is not available."
  },
  "relativeTime": {
    "justNow": "Just now",
    "minutesAgo": "{{count}}m ago",
    "todayAt": "Today at {{time}}",
    "yesterdayAt": "Yesterday at {{time}}",
    "dateAt": "{{month}}/{{day}} {{time}}"
  },
  "apiError": {
    "UNAUTHENTICATED": "Authentication is required.",
    "FORBIDDEN": "You do not have permission to perform this action.",
    "COMPETITION_NOT_FOUND": "Competition not found.",
    "TEAM_NOT_FOUND": "Team not found.",
    "SUBMISSION_NOT_FOUND": "Submission not found.",
    "SUBMISSION_DEADLINE_PASSED": "The submission deadline has passed.",
    "SUBMISSION_ALREADY_LOCKED": "This submission is locked.",
    "FILE_TOO_LARGE": "The uploaded file is too large.",
    "FILE_TYPE_NOT_ALLOWED": "This file type is not allowed.",
    "JUDGE_NOT_ASSIGNED": "You are not assigned to this submission.",
    "SCORE_ALREADY_LOCKED": "This score is locked and cannot be modified.",
    "CONFLICT_OF_INTEREST": "A declared conflict of interest prevents this action.",
    "VALIDATION_ERROR": "The request payload is invalid.",
    "RATE_LIMITED": "Too many requests. Please try again later.",
    "NOT_FOUND": "Not found.",
    "INTERNAL_ERROR": "An unexpected error occurred.",
    "BOOTSTRAP_UNAVAILABLE": "Initial platform bootstrap is not available.",
    "USER_NOT_FOUND": "User not found.",
    "LAST_SUPER_ADMIN_PROTECTED": "This account is the platform's only active super admin and cannot be removed or suspended.",
    "USER_NOT_ACTIVE": "This action requires an active account.",
    "EVENT_BOOKING_CONFLICT": "The shuttle reservation could not be completed.",
    "ROLE_NOT_FOUND": "Role grant not found.",
    "LAST_COMPETITION_ADMIN_PROTECTED": "This competition must keep at least one competition administrator, so this grant cannot be revoked.",
    "PASSWORD_CHANGE_REQUIRED": "You must set a new password before continuing.",
    "JUDGE_INVITATION_NOT_FOUND": "This invitation is invalid, expired, or already used.",
    "COMPETITION_REQUEST_NOT_FOUND": "Competition creation request not found.",
    "COMPETITION_REQUEST_NOT_APPROVABLE": "This request is not in a state that allows that action.",
    "COMPETITION_REQUEST_APPROVAL_IN_PROGRESS": "This request is already being approved. Please try again shortly.",
    "SESSION_NOT_FOUND": "Session not found.",
    "LOCAL_PASSWORD_NOT_AVAILABLE": "This account is managed by an identity provider and has no local password to change.",
    "ELIGIBILITY_NOT_FOUND": "Eligibility record not found.",
    "ELIGIBILITY_PROOF_NOT_FOUND": "Enrollment proof not found.",
    "ELIGIBILITY_PROOF_NOT_CURRENT": "This is no longer the current enrollment proof.",
    "CATEGORY_CAPACITY_FULL": "This category has reached its team capacity. Please choose another category or contact the organizer.",
    "ROUND_SCORING_MODE_CONFLICT": "This round's scoring input mode does not allow this action."
  }
}
